import React, { Fragment } from "react";

export default function Input(props){
    return(
        <Fragment>
            <textarea {...props} />
        </Fragment>  
    );
}